<h2 mat-dialog-title>New Voice Macro</h2>

<mat-dialog-content class="mat-typography">

	<div>
		<mat-form-field class="dialog-field">
			<mat-label>Section</mat-label>
			<mat-select cdkFocusInitial [(value)]="data.section">
				@for (section of sections; track section) {
				<mat-option [value]="section.shortName">{{section.name}}</mat-option>
				}
			</mat-select>
		</mat-form-field>
	</div>

	<div>
		<mat-form-field class="dialog-field">
			<mat-label>Phrase</mat-label>
			<input matInput [(ngModel)]="data.phrase" />
		</mat-form-field>
	</div>

	<div>
		<mat-form-field class="dialog-field">
			<mat-label>Substitution</mat-label>
			<textarea class="dialog-textarea" matInput [(ngModel)]="data.substitution" ></textarea>
		</mat-form-field>
	</div>
</mat-dialog-content>

<mat-dialog-actions align="end">
	<button mat-button mat-dialog-close >cancel</button>
	<button mat-button [mat-dialog-close]="data" [disabled]="!data.substitution || !data.phrase || !data.section">save</button>
</mat-dialog-actions>
